import { takeEvery } from 'redux-saga/effects';

import actionTypes from '../../actionTypes';
import {
	getItemBasicInfo,
	getItemNetSalesSummaryCards,
	getItemInStockSummaryCards,
	getItemStoreCountSummaryCards,
	getItemNilPickRateSummaryCards,
	getItemUnitOnHandInventory,
	getItemRetailOnHandInventory,
	getItemChannelBreakdown,
	getItemNetSales,
	getItemUnits,
	getItemRelativeNetSales,
	getItemRelativeUnits,
	getUnitsChannelBreakdown,
	getItemInventoryOnHand,
	getItemInventoryOnHandUnit,
	getItemInventoryOnOrder,
	getItemInventoryOnOrderUnit,
	getItemInventoryDCToStore,
	getItemInventoryDCToStoreUnit,
	getItemInventoryInWhse,
	getItemInventoryInWhseUnit,
	getItemInventoryTrendSaga,
	getItemInStockSaga,
	getNilPickRateSaga,
	getFirstTimePickRateSaga,
	getPreSubstituteRateSaga,
	getPostSubstituteRateSaga,
	getNetSalesMapSummarySaga,
	getWeekOfSupplyStoreSaga,
	getWeekOfSupplyDCSaga,
	getItemLocationGridStateData,
	getItemLocationGridStoreData,
	getMapConfig,
} from './itemDrillDownSaga';

export default function* itemDrillDownSagaWatcher() {
	yield takeEvery(actionTypes.GET_ITEM_BASIC_INFO, getItemBasicInfo);
	yield takeEvery(
		actionTypes.GET_ITEM_NET_SALES_SUMMARY_CARD,
		getItemNetSalesSummaryCards
	);
	yield takeEvery(
		actionTypes.GET_ITEM_IN_STOCK_SUMMARY_CARD,
		getItemInStockSummaryCards
	);
	yield takeEvery(
		actionTypes.GET_ITEM_STORE_COUNT_SUMMARY_CARD,
		getItemStoreCountSummaryCards
	);
	yield takeEvery(
		actionTypes.GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD,
		getItemNilPickRateSummaryCards
	);
	yield takeEvery(
		actionTypes.GET_ITEM_UNIT_ON_HAND_INVENTORY,
		getItemUnitOnHandInventory
	);
	yield takeEvery(
		actionTypes.GET_ITEM_RETAIL_ON_HAND_INVENTORY,
		getItemRetailOnHandInventory
	);
	yield takeEvery(
		actionTypes.GET_ITEM_CHANNEL_BREAKDOWN,
		getItemChannelBreakdown
	);
	yield takeEvery(actionTypes.GET_ITEM_NET_SALES, getItemNetSales);
	yield takeEvery(actionTypes.GET_ITEM_UNITS, getItemUnits);
	yield takeEvery(
		actionTypes.GET_ITEM_RELATIVE_NET_SALES,
		getItemRelativeNetSales
	);
	yield takeEvery(actionTypes.GET_ITEM_RELATIVE_UNITS, getItemRelativeUnits);
	yield takeEvery(
		actionTypes.GET_ITEM_CHANNEL_BREAKDOWN,
		getUnitsChannelBreakdown
	);
	yield takeEvery(actionTypes.GET_ITEM_ONHAND, getItemInventoryOnHand);
	yield takeEvery(
		actionTypes.GET_ITEM_ONHAND_UNITS,
		getItemInventoryOnHandUnit
	);
	yield takeEvery(actionTypes.GET_ITEM_ONORDER, getItemInventoryOnOrder);
	yield takeEvery(
		actionTypes.GET_ITEM_ONORDER_UNITS,
		getItemInventoryOnOrderUnit
	);
	yield takeEvery(actionTypes.GET_ITEM_DCTOSTORE, getItemInventoryDCToStore);
	yield takeEvery(
		actionTypes.GET_ITEM_DCTOSTORE_UNITS,
		getItemInventoryDCToStoreUnit
	);
	yield takeEvery(actionTypes.GET_ITEM_INWHSE, getItemInventoryInWhse);
	yield takeEvery(
		actionTypes.GET_ITEM_INWHSE_UNITS,
		getItemInventoryInWhseUnit
	);
	yield takeEvery(actionTypes.GET_ITEM_INV_TREND, getItemInventoryTrendSaga);
	yield takeEvery(actionTypes.GET_ITEM_INSTOCK, getItemInStockSaga);
	yield takeEvery(actionTypes.GET_NIL_PICK_RATE, getNilPickRateSaga);
	yield takeEvery(actionTypes.GET_NIL_PICK_RATE, getFirstTimePickRateSaga);
	yield takeEvery(actionTypes.GET_NIL_PICK_RATE, getPreSubstituteRateSaga);
	yield takeEvery(actionTypes.GET_NIL_PICK_RATE, getPostSubstituteRateSaga);
	yield takeEvery(
		actionTypes.GET_ITEM_NET_SALES_MAP_SUMMARY,
		getNetSalesMapSummarySaga
	);
	yield takeEvery(
		actionTypes.GET_WEEK_OF_SUPPLY_STORE_DATA,
		getWeekOfSupplyStoreSaga
	);
	yield takeEvery(
		actionTypes.GET_WEEK_OF_SUPPLY_DC_DATA,
		getWeekOfSupplyDCSaga
	);
	yield takeEvery(
		actionTypes.GET_ITEM_LOCATION_GRID_STATE_DATA,
		getItemLocationGridStateData
	);
	yield takeEvery(
		actionTypes.GET_ITEM_LOCATION_GRID_STORE_DATA,
		getItemLocationGridStoreData
	);
	yield takeEvery(actionTypes.GET_MAP_KEY, getMapConfig);
}
